import lscache from 'lscache';
import React, { FC, useEffect } from 'react';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import achIcon from 'static/images/icons/ach.png';
import wireIcon from 'static/images/icons/exchange.png';
import { openIRAWithdrawLimitsModal } from '../helper';
import './style.scss';

const CONFIRMED_DATE_KEY = 'IRA_WITHDRAW_LIMIT_CONFIRMED_DATE';

const SelectWay: FC<{ isIRA?: boolean }> = ({ isIRA }) => {
    const wayList = [
        {
            iconSrc: achIcon,
            title: isIRA ? __('ACH Distribution') : __('Withdraw ACH Transfer'),
            desc: __('US Dollar'),
            link: 'ach'
        },
        {
            iconSrc: wireIcon,
            title: isIRA ? __('Wire Distribution') : __('Wire Transfer:withdraw'),
            desc: __('US Dollar'),
            link: 'wire'
        }
    ];

    useEffect(() => {
        const today = dayjs().format('YYYY-MM-DD');
        const confirmed = today === lscache.get(CONFIRMED_DATE_KEY);

        if (confirmed) {
            return;
        }

        openIRAWithdrawLimitsModal(() => {
            lscache.set(CONFIRMED_DATE_KEY, today, 1440);
        });
    }, []);

    return (
        <div className="withdraw-select-way-root">
            <h3 className="main-title">{isIRA ? __('Choose Distribution Method') : __('Choose Withdrawal Method')}</h3>
            <div className="way-list">
                {wayList.map(({ iconSrc, title, desc, link }, index) => {
                    return (
                        <Link to={link} key={index}>
                            <div className="item">
                                <img className="icon" src={iconSrc} alt={title} />
                                <div className="info">
                                    <h4 className="title">{title}</h4>
                                    <div className="desc">{desc}</div>
                                </div>
                            </div>
                        </Link>
                    );
                })}
            </div>
        </div>
    );
};

export default SelectWay;
